export default __webpack_public_path__ + "static/media/NoirPro-Regular.38a6e5bf.woff2";